import React, { useState } from "react";
import { useLogin } from "../../../hooks/useLogin";
import FesbLogo from "../../../resources/login/Fesb-logo.png";
import DumpLogo from "../../../resources/login/dump-logo.png";
import ErrorIcon from "../../../resources/login/error_icon.svg";
import FesbLogoFooter from "../../../resources/login/fesb-logo-footer.png";
import LoginBtnFocus from "../../../resources/login/login-btn-focus.png";
import LoginBtnHover from "../../../resources/login/login-btn-hover-1.png";
import LoginBtn from "../../../resources/login/login-btn.png";
import styles from "./LoginForm.module.css";

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoginBtnHovered, setIsLoginBtnHovered] = useState(false);
  const [isLoginBtnClicked, setIsLoginBtnClicked] = useState(false);
  const { login, error, isLoading } = useLogin();

  const handleSubmit = async (e) => {
    e.preventDefault();

    await login(username, password);
  };

  const handleMouseDown = (e) => {
    setIsLoginBtnHovered(false);
    setIsLoginBtnClicked(true);
  };

  const handleMouseUp = (e) => {
    setIsLoginBtnHovered(false);
    setIsLoginBtnClicked(false);
  };

  const handleMouseEnter = (e) => {
    setIsLoginBtnHovered(true);
  };

  return (
    <div className={styles.loginScreenContainer}>
      <div className={styles.bottomGlow} />
      <div className={styles.formContainer}>
        <div className={styles.logoContainer}>
          <img src={FesbLogo} />
        </div>
        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <div className={styles.formContent}>
            <h3 style={{ fontWeight: "200" }}>FESB Prijava</h3>
            <div className={styles.inputsContainer}>
              <input
                type="text"
                placeholder="Vaše korisničko ime"
                name="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Vaša zaporka"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <div className={styles.loginError}>
                <img src={ErrorIcon} />
                <p>{error}</p>
              </div>
            )}
          </div>
        </form>
        <button
          onMouseEnter={handleMouseEnter}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseUp}
          onMouseUp={handleMouseUp}
          disabled={isLoading}
          onClick={handleSubmit}
          className={styles.button}
        >
          <img
            className={styles.button}
            src={
              isLoginBtnHovered && !isLoginBtnClicked ? LoginBtnHover : LoginBtn
            }
          />
          {isLoginBtnClicked && (
            <img className={styles.button} src={LoginBtnFocus} />
          )}
        </button>
        <div className={styles.attentionFeedContainer}>
          <h3>Prijavljujete se na FESB Prijava projekta</h3>
          <p>
            Nakon uspješne prijave bit ćete preusmjereni natrag na sustav FESB
            Prijava projekta
          </p>
        </div>
      </div>
      <footer className={styles.footer}>
        <img src={FesbLogoFooter} width={59} height={28} />
        <p>© {new Date().getFullYear()} FESB. Sva prava pridržana.</p>
        <img src={DumpLogo} width={84} height={27} />
      </footer>
    </div>
  );
};

export default LoginForm;
